import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Our Full-fledged Tech Stack for{" "}
              <span>IoT Software Development</span>
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              With a professional team of blockchain experts, we have a firm
              grip on the latest tech stack associated with this prime
              technology. Our diverse team of blockchain app developers is
              experienced enough to work on multiple tools and platforms to
              ensure the right development of your desired product.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Cloud databases and warehouses">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/cloud-database/amazon_redshift.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Amazon Redshift</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/cloud-database/amazon_dynam_DB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Amazon Dynamo DB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/cloud-database/azure_cosmo_DB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure Cosmos DB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/cloud-database/azure_sql_database.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure SQL Database</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/cloud-database/google_cloud_datastore.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud Datastore</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="IoT data analytics and machine learning">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/iot-analytics/apche_hbase.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Apache HBase</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/iot-analytics/cassandra.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Cassandra</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/iot-analytics/hadoop.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Hadoop</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/iot-analytics/matlab.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Matlab</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/iot-analytics/octave.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Octave</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/iot-analytics/R-Language.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>R-Language</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="AWS IOT">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/aws-iot/AWS_IoT.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS IoT</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/aws-iot/AWS_Iot_thinks_graph.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS Iot Thinks Graph</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/aws-iot/AWS_IoTDevice.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS IoT Device</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/aws-iot/AWS_IotEvents.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS IoT Events</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/aws-iot/Things_Board.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Things Board</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/aws-iot/Think_Speak.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Think Speak</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Connectivity">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/connectivity/bluetooth.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Bluetooth</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/connectivity/gsm.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GSM</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/connectivity/lora.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Lora</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/connectivity/nfc_logo.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Nfc</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/connectivity/rfid.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>RFID</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iot-new/connectivity/wifi.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>WIFI</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
